import { ButtonStyle } from './button.types';

function buttonStyleDefaultData({
  defaultColor,
  hoverColor,
  secondaryHoverColor,
}: {
  defaultColor: string;
  hoverColor: string;
  secondaryHoverColor: string;
}): {
  primary: ButtonStyle;
  secondary: ButtonStyle;
  discreet: ButtonStyle;
} {
  return {
    primary: {
      height: '40px',
      background: {
        default: defaultColor,
        hover: '#0557d5',
        disabled: '#699ae6',
      },
      textColor: {
        default: 'white',
        hover: 'white',
        disabled: 'white',
      },
      borderRadius: '50px',
    },
    secondary: {
      height: '40px',
      background: {
        default: 'white',
        hover: secondaryHoverColor,
        disabled: '#9abfcf',
      },
      textColor: {
        default: defaultColor,
        hover: defaultColor,
        disabled: '#025fc7',
      },
      borderColor: {
        default: '#D9D9D9',
        hover: defaultColor,
        disabled: '#83a8b9',
      },
      borderRadius: '50px',
    },
    discreet: {
      height: '40px',
      background: {
        default: 'transparent',
        hover: secondaryHoverColor,
        disabled: '#9abfcf',
      },
      textColor: {
        default: defaultColor,
        hover: hoverColor,
        disabled: '#025fc7',
      },
      borderColor: {
        default: 'unset',
        hover: 'unset',
      },
      borderRadius: '50px',
    },
  };
}

export { buttonStyleDefaultData };
